import { Input } from '@nazka/nazka.mapframe.components';

import './number-input.styl';

function NumberInput({
  type = 'number',
  value,
  onChange,
  placeholder = '',
  className = '',
  error = '',
}) {
  // Set step based on type - integers have step of 1, numbers have step of 0.01
  const step = type === 'int' ? 1 : 0.01;

  return (
    <div className={`number-input${className ? ` ${className}` : ''}`}>
      <Input
        type="number"
        value={value || ''}
        onInputChange={e => onChange(e.target.value)}
        placeholder={placeholder}
        className={`number-input__input${error ? ' number-input__input--error' : ''}`}
        rootElProps={{
          step,
        }}
      />
      {error && (
        <p className="number-input__error">
          {error}
        </p>
      )}
    </div>
  );
}

export default NumberInput;